<template>
  <div class="home">
    <img alt="Vue logo" src="../assets/logo.png">
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'home',
  created() {
	  console.log("home......")
  	this.getList()
  },
  methods:{
	  
  }
}
</script>
